import Vue from 'vue'
import App from './App.vue'
import VTooltip from 'v-tooltip'
import 'vue-tel-input/dist/vue-tel-input.css'
import VueTelInput from 'vue-tel-input'
// Vuesax Component Framework
import Vuesax from 'vuesax'
import 'material-icons/iconfont/material-icons.css' //Material Icons
import 'vuesax/dist/vuesax.css' // Vuesax
import VueRecaptcha from 'vue-recaptcha'
import './utils/vee-validate-rules'
Vue.use(Vuesax)

// Initialize the plugin with your site key
Vue.component('vue-recaptcha', VueRecaptcha)

// tooltip
Vue.use(VTooltip)

// Define your global options here
const vueTelInputOptions = {
  autoFormat: false,
  inputOptions: {
    showDialCode: true
    // tabindex: '3',
    // maxLength: 15,
    // minLength: 10
  },
  dropdownOptions: {
    showSearchBox: true,
    // tabindex: '4',
    searchBoxPlaceholder: 'Search Country'
  },
  validCharactersOnly: true
}

// vue tel input
Vue.use(VueTelInput, vueTelInputOptions)

// axios
import axios from './axios.js'
Vue.prototype.$http = axios

// Strategic pivot feature flags (Phase 0)
import featureFlags from './config/featureFlags'
Vue.prototype.$featureFlags = featureFlags

// Filters
import './filters/filters.js'

// Theme Configurations
import '../themeConfig.js'

// Globally Registered Components
import './globalComponents.js'

// Styles: SCSS
import './assets/scss/main.scss'

// Tailwind
import '@/assets/css/main.css'

// Vue Router
import router from './router'

// Vuex Store
import store from './store'

// Vuejs - Vue wrapper for hammerjs
import { VueHammer } from 'vue2-hammer'
Vue.use(VueHammer)

// VeeValidate
import VeeValidate from 'vee-validate'
Vue.use(VeeValidate)

// PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'

// Feather font icon
require('./assets/css/iconfont.css')

/** vue select */
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css'

// Vue select css
// Note: In latest version you have to add it separately
// import 'vue-select/dist/vue-select.css';

Vue.config.productionTip = false

store.$http = axios

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
